import { BaseRootLayout } from "@/shared/components/layout/base-root-layout";
import { BaseLayout } from "@/shared/components/layout/base-layout";
import { BaseNotLoginLayout } from "@/shared/components/layout/base-not-login-layout";
import { Home } from "@/features/home/index";
import { MyData } from "@/features/my-data/index";
import { Login } from "@/features/auth/index";
import { SignUp } from "@/features/user/index";
import { SignUpDone } from "@/features/user/pages/sign-up-done";
import { SignUpPass } from "@/features/user/pages/sign-up-pass";
import { SignUpUser } from "@/features/user/pages/sign-up-user";
import { SignUpCompleted } from "@/features/user/pages/sign-up-completed";
import { FirstAuth } from "@/features/user/pages/first-auth";
import { FirstAuthCompleted } from "@/features/user/pages/first-auth-completed";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { UpdateIdCompleted } from "./features/user/pages/update-id-completed";
import { ResetPass } from "@/features/user/pages/reset-pass";
import { ResetPassDone } from "@/features/user/pages/reset-pass-done";
import { ResetPassSet } from "@/features/user/pages/reset-pass-set";
import { ResetPassCompleted } from "@/features/user/pages/reset-pass-completed";
import { Http404Error } from "@/pages/error/404/index";

import { LoginProvider } from "@/features/auth/contexts/login-context";
import { AccountGroupsProvider } from "@/features/accounts/account-group/contexts/account-groups-context";
import { ModalProvider } from "@/shared/components/modal/contexts/modal-context";
import { TradesProvider } from "@/features/accounts/shared/contexts/trades-context";
import { AccountPollingProvider } from "@/features/accounts/shared/contexts/account-polling-context";
import { InstitutionsProvider } from "@/features/institutions/contexts/institutions-context";
import { PaymentProvider } from "@/features/accounts/payment/scraping/contexts/payment-context";
import { NewsProvider } from "@/features/news/contexts/news-context";
import { TradeJumpProvider } from "@/features/trade-jump/contexts/trade-jump-context";
import { OneTimePassProvider } from "@/features/accounts/payment/scraping/contexts/one-time-pass-context";
import { RootClassController } from "./root-classname-controller";
import { ErrorDialogProvider } from "@/shared/context/error-provider";
import { UsersIntegrationProvider } from "@/features/user/contexts/users-integration-context"
import { ReceiveMailsProvider } from "@/features/user/contexts/receive-mails-context";


createRoot(document.getElementById('react-root')!).render(
  
  <BrowserRouter>
    <ErrorDialogProvider>
      <RootClassController />
          
      <Routes>
        <Route path="" element={<BaseRootLayout />}>
          <Route path="" element={<BaseNotLoginLayout />}>
            <Route path="/" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/sign_up" element={<SignUp />} />
            <Route path="/reset_pass" element={<ResetPass />} />
          </Route>
          <Route path="" element={<BaseNotLoginLayout />}>
            <Route path="/sign_up_done" element={<SignUpDone />} />
          </Route>
          <Route path="" element={<BaseNotLoginLayout />}>
            <Route path="/sign_up_pass" element={<SignUpPass />} />
          </Route>
          <Route path="" element={<BaseNotLoginLayout />}>
            <Route path="/sign_up_user" element={<SignUpUser />} />
          </Route>
          <Route path="" element={<BaseNotLoginLayout />}>
            <Route path="/sign_up_completed" element={<SignUpCompleted />} />
          </Route>
          <Route path="" element={<BaseNotLoginLayout />}>
            <Route path="/first_auth" element={<FirstAuth />} />
          </Route>
          <Route path="" element={<BaseNotLoginLayout />}>
            <Route path="/first_auth_completed" element={<FirstAuthCompleted />} />
          </Route>
          <Route path="" element={<BaseNotLoginLayout />}>
            <Route path="/update_id_completed" element={<UpdateIdCompleted />} />
          </Route>
          <Route path="" element={<BaseNotLoginLayout />}>
            <Route path="/reset_pass_done" element={<ResetPassDone />} />
          </Route>
          <Route path="" element={<BaseNotLoginLayout />}>
            <Route path="/reset_pass_set" element={<ResetPassSet />} />
          </Route>
          <Route path="" element={<BaseNotLoginLayout />}>
            <Route path="/reset_pass_completed" element={<ResetPassCompleted />} />
          </Route>
          <Route element={
            <LoginProvider>
              <TradeJumpProvider>
                <AccountGroupsProvider>
                  <TradesProvider>
                  <InstitutionsProvider>
                    <PaymentProvider>
                      <ModalProvider>
                        <NewsProvider>
                          <AccountPollingProvider>
                            <OneTimePassProvider>
                              <UsersIntegrationProvider>
                                <ReceiveMailsProvider>
                                  <BaseLayout />
                                </ReceiveMailsProvider>
                              </UsersIntegrationProvider>
                            </OneTimePassProvider>
                          </AccountPollingProvider>
                      </NewsProvider>
                      </ModalProvider>
                    </PaymentProvider>
                  </InstitutionsProvider>
                  </TradesProvider>
                </AccountGroupsProvider>
              </TradeJumpProvider>
            </LoginProvider>
          }>
            <Route path="/home" element={<Home />}/>
            <Route path="/mydata" element={<MyData />}/>
            <Route path="*" element={<Http404Error />} />
          </Route>
        </Route>
      </Routes>
    </ErrorDialogProvider>
  </BrowserRouter>
)
